(function () {
    // <product-recommendations> (rendered by both cart-product-related.liquid and
    if (!customElements.get('product-recommendations')) {
        customElements.define('product-recommendations', class ProductRecommendations extends HTMLElement {
            constructor() {
                super();

                const handleIntersection = (entries, observer) => {
                    if (!entries[0].isIntersecting) return;
                    observer.unobserve(this);

                    fetch(this.dataset.url)
                        .then((response) => response.text())
                        .then((text) => {
                            const html = document.createElement('div');
                            html.innerHTML = text;
                            const recommendations = html.querySelector('product-recommendations');

                            if (recommendations && recommendations.innerHTML.trim().length) {
                                this.innerHTML = recommendations.innerHTML;
                            }
                        })
                        .catch((e) => {
                            console.error(e);
                        });
                };

                new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
            }
        });
    }

    // Everything below is gated behind 'twc:ready' (dispatched from scripts.liquid once
    document.addEventListener('twc:ready', function () {
        // twc:ready itself only fires at/after DOMContentLoaded (see scripts.liquid), so there's
        (function () {
            // <product-recommendations> (rendered by cart-product-related.liquid and
            const productRecommendationsElements = document.querySelectorAll("product-recommendations");
            productRecommendationsElements.forEach(function (element) {
                // wishlist.init() rewrites each button's icon/text children in place, which shows
                // up here as addedNodes - reacting to those re-ran init() forever (every wishlist
                // button on the page, incl. mini-cart and cart page, blinking nonstop). Only react
                // to added nodes that are outside a wishlist button, and never to init()'s own pass.
                new MutationObserver(function (mutationsList) {
                    if (isReinitializingWishlist) return;
                    for (const mutation of mutationsList) {
                        const target = /** @type {Element} */ (mutation.target);
                        if (target.closest?.('.wrapper-button-collection')) continue;
                        const addedElements = [...mutation.addedNodes].filter(function (n) {
                            return n instanceof Element && !n.classList.contains('wrapper-button-collection');
                        });
                        if (addedElements.length) {
                            dispatchWishlistEvent();
                            break;
                        }
                    }
                }).observe(element, { childList: true, subtree: true });
            });

            // dy-product-recs-tabs.js swaps each skeleton's children for a fetched .product-card
            const recsTabsCarouselGrids = document.querySelectorAll(".dy-product-recs-tabs__grid--carousel");
            recsTabsCarouselGrids.forEach(function (grid) {
                new MutationObserver(function (mutationsList) {
                    for (const mutation of mutationsList) {
                        const addedNodes = [...mutation.addedNodes];
                        if (addedNodes.some(function (n) {
                            return n instanceof Element && n.classList.contains('product-card');
                        })) {
                            dispatchWishlistEvent();
                            break;
                        }
                    }
                }).observe(grid, { childList: true, subtree: true });
            });

            // cart-recommendations.js (.cart-recommendations__grid on the cart page) swaps each
            const cartRecommendationsGrids = document.querySelectorAll(".cart-recommendations__grid");
            cartRecommendationsGrids.forEach(function (grid) {
                new MutationObserver(function (mutationsList) {
                    for (const mutation of mutationsList) {
                        const addedNodes = [...mutation.addedNodes];
                        if (addedNodes.some(function (n) {
                            return n instanceof Element && n.classList.contains('product-card');
                        })) {
                            dispatchWishlistEvent();
                            break;
                        }
                    }
                }).observe(grid, { childList: true, subtree: true });
            });

            // The wishlist list page (/pages/wishlist) renders its items into #ucwl-page-container
            // entirely via the vendor's own client-side JS (confirmed earlier for the price-format
            // fix above: `document.querySelector("#ucwl-page-container .product-list")`), which can
            // take longer to populate than the one-shot window 'load' trigger below waits for - on
            // this page specifically, the header's .wishlist__launch-point count-item was seen
            // staying blank because by the time 'load' fired and called dispatchWishlistEvent(),
            // theWishlist wasn't done populating this container yet, and nothing else on this page
            // (no product grid, no facets, no button click yet) ever re-triggers it afterward.
            // #ucwl-page-container may not even exist in the DOM yet at this point (the vendor
            // appears to build parts of its own UI dynamically rather than relying solely on
            // server-rendered markup) - watch document.body instead of the container itself so
            // this doesn't depend on it already being there when this observer is attached.
            new MutationObserver(function () {
                if (isReinitializingWishlist) return;
                if (document.querySelector('#ucwl-page-container')) {
                    dispatchWishlistEvent();
                }
            }).observe(document.body, { childList: true, subtree: true });
        })();

        // Cart / cart-drawer "Move to Wishlist" button: injected by the third-party wishlist
        document.addEventListener('click', function (event) {
            const moveToWishlistButton = event.target instanceof Element
                ? event.target.closest('.cart-items__details .osc-css.wrapper-button-collection button')
                : null;
            if (moveToWishlistButton) {
                event.preventDefault();
            }
        });

        // Add/remove wishlist toggle click (.button-collection-wishlist, rendered by
        function readWishlistCount() {
            const wishlist = /** @type {any} */ (window).theWishlist;
            try {
                // theWishlist.countItemWishlist() returns window.__thisUcwl.totalItemsAllWishlists,
                // which goes stale after a local add elsewhere on the site (see the comment where
                // this used to be the only fallback). But confirmed live on the wishlist list page
                // itself, it's the opposite problem: totalItemsAllWishlists is fresh and correct
                // right after that page's own getWishlist() fetch, while wishlistList[].items.item
                // is empty there, since the server response's wishlist objects don't use the same
                // {items: {item: [...]}} shape the client-side mutation functions build locally.
                // Neither signal is reliably correct in every context - each just undercounts
                // differently - so take whichever is higher instead of preferring one.
                const wishlistList = /** @type {any} */ (window).__thisUcwl && /** @type {any} */ (window).__thisUcwl.wishlistList;
                const summedFromLists = Array.isArray(wishlistList)
                    ? wishlistList.reduce(function (sum, wl) {
                        return sum + ((wl.items && wl.items.item && wl.items.item.length) || 0);
                    }, 0)
                    : 0;
                const cachedTotal = (/** @type {any} */ (window).__thisUcwl && /** @type {any} */ (window).__thisUcwl.totalItemsAllWishlists) || 0;
                const best = Math.max(summedFromLists, cachedTotal);
                if (best) return best;
                return wishlist && typeof wishlist.countItemWishlist === 'function'
                    ? wishlist.countItemWishlist()
                    : undefined;
            } catch {
                return undefined;
            }
        }

        function pollWishlistCountChange() {
            const startCount = readWishlistCount();
            let attempts = 0;
            const poll = setInterval(function () {
                attempts += 1;
                const currentCount = readWishlistCount();
                if (currentCount !== undefined && currentCount !== startCount) {
                    clearInterval(poll);
                    dispatchWishlistEvent();
                } else if (attempts >= 25) {
                    clearInterval(poll);
                }
            }, 200);
        }

        document.addEventListener('click', function (event) {
            if (!(event.target instanceof Element)) return;
            const trigger = event.target.closest(
                '.button-collection-wishlist, .modal-footer button.btn-save, .modal-footer button.btn-remove'
            );
            if (!trigger) return;
            pollWishlistCountChange();
        });

        // The third-party wishlist app sets its own title (e.g. "Add to wishlist") on
        function stripWishlistButtonTitles() {
            document.querySelectorAll('.button-collection-wishlist[title]').forEach(function (button) {
                button.removeAttribute('title');
            });
        }
        stripWishlistButtonTitles();
        new MutationObserver(stripWishlistButtonTitles).observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['title']
        });

        // Re-init the wishlist whenever the cart changes (add/remove/qty update, from any
        document.addEventListener('shopify:cart:lines-update', function (event) {
            const promise = /** @type {any} */ (event).promise;
            if (promise && typeof promise.then === 'function') {
                promise.then(dispatchWishlistEvent).catch(dispatchWishlistEvent);
            } else {
                dispatchWishlistEvent();
            }
        });

        // PLP wishlist elements
        /** @type {ReturnType<typeof setTimeout>} */
        let productGridDebounce;

        // wishlist.init() re-renders each button's icon/title/class in place (confirmed live -
        // this is what was causing every wishlist button on a Boost-rendered grid to flicker
        // continuously: a broad MutationObserver reacted to init()'s own DOM changes by calling
        // dispatchWishlistEvent() again, forever - see the identical fix and explanation in
        // assets/boost-sd-custom.js's reinitWishlistButtons). The #ucwl-page-container observer
        // below has the same broad "react to any nearby mutation" shape, so it's exposed to the
        // same loop on the wishlist list page - set this flag around init() so that observer can
        // tell "a mutation I need to react to" apart from "a mutation caused by my own last
        // reaction" and skip the latter. The other, narrower observers in this file (watching for
        // a specific added-node shape like .product-card) aren't at risk the same way, since
        // init()'s attribute/icon tweaks never match what they're specifically looking for.
        let isReinitializingWishlist = false;

        function dispatchWishlistEvent() {
            clearTimeout(productGridDebounce);

            productGridDebounce = setTimeout(function () {
                // Same guard as reinitWishlistButtons in assets/boost-sd-custom.js: the vendor's
                // initTheWishlist handler reads __thisUcwl.wishlistList.length unguarded, so firing
                // it before the vendor has loaded that list throws. The vendor fires it itself once
                // the list is in.
                const ucwl = /** @type {any} */ (window).__thisUcwl;
                if (!ucwl || !Array.isArray(ucwl.wishlistList)) return;
                isReinitializingWishlist = true;
                const wishlist = /** @type {any} */ (window).theWishlist;
                if (wishlist && typeof wishlist.init === 'function') {
                    wishlist.init();
                }
                document.body.dispatchEvent(new CustomEvent('initTheWishlist'));
                // Cleared via a macrotask, not synchronously here - the MutationObserver
                // callback below runs as a microtask (queued once the current synchronous work,
                // including this whole setTimeout callback, finishes), so it needs to still see
                // `true` when it checks.
                setTimeout(function () {
                    isReinitializingWishlist = false;
                }, 300);
            }, 150);
        }

        // Sort/filter/pagination can go through either Dynamic Yield's own pagination
        new MutationObserver(function (mutationsList) {
            for (const mutation of mutationsList) {
                if (mutation.type !== 'attributes' || mutation.attributeName !== 'aria-busy') continue;
                const target = /** @type {Element} */ (mutation.target);
                if (target.classList?.contains('product-grid') && !target.hasAttribute('aria-busy')) {
                    dispatchWishlistEvent();
                    break;
                }
            }
        }).observe(document.body, {
            attributes: true,
            attributeFilter: ['aria-busy'],
            subtree: true
        });

        // Native Shopify facets/sort/filter/pagination completion - fires regardless of
        ['shopify:search:update', 'shopify:collection:update'].forEach(function (eventName) {
            document.addEventListener(eventName, function (event) {
                const promise = /** @type {any} */ (event).promise;
                if (promise && typeof promise.then === 'function') {
                    promise.then(dispatchWishlistEvent).catch(dispatchWishlistEvent);
                } else {
                    dispatchWishlistEvent();
                }
            });
        });

        window.addEventListener('load', function () {
            dispatchWishlistEvent();
        });

        // wishlist page format price
        function formatPriceText(elements) {
        elements.forEach(function (element) {
            if (element.dataset.processed === "true") return;
        
            // Extract numeric value only (handles 105.00, 140, etc)
            const match = element.textContent.match(/([\d,.]+)/);
            if (!match) return;
        
            const value = parseFloat(match[1].replace(',', ''));
        
            // Format as $140 (no decimals)
            element.textContent = `$${Math.round(value)}`;
        
            element.dataset.processed = "true";
        });
        }
        
        const observer = new MutationObserver(() => {
        // .ucwl-osc-css never exists anywhere in the vendor's own script or this theme - it's a
        // dead selector, so this observer never matched anything. The wishlist list page's real
        // container is #ucwl-page-container (confirmed in the vendor's own script, e.g.
        // `document.querySelector("#ucwl-page-container .product-list")`), with each item's price
        // rendered as a plain .product-price div inside it.
        const elements = document.querySelectorAll(
            '#ucwl-page-container .product-price:not([data-processed])'
        );
        formatPriceText(elements);
        });
        
        observer.observe(document.body, {
        childList: true,
        subtree: true
        });

        // Feature flag: temporarily disables the auto-preselect-default-wishlist behavior below
        const AUTO_PRESELECT_DEFAULT_WISHLIST = false;

        // Wishlist "add to list" modal (.wishlist-list / .variant-item-list, vendor-rendered): the
        const wishlistListObserver = new MutationObserver(function (mutationsList) {
        for (const mutation of mutationsList) {
            const addedNodes = [...mutation.addedNodes];
            const listNode = /** @type {Element | undefined} */ (addedNodes.find(function (n) {
            return n instanceof Element && (
                n.matches?.('.wishlist-list, .variant-item-list') ||
                n.querySelector?.('.wishlist-list, .variant-item-list')
            );
            }));
            if (!listNode) continue;

            // Force a manual selection instead: the vendor can render this modal with a variant
            const modalContainer = listNode.closest?.('.modal-document') || listNode;
            const alreadyClearedThisModal = modalContainer instanceof HTMLElement
            && modalContainer.dataset.wishlistSelectionCleared === 'true';
            if (modalContainer instanceof HTMLElement) {
            modalContainer.dataset.wishlistSelectionCleared = 'true';
            }
            if (!alreadyClearedThisModal) {
            document.querySelectorAll(
                '.variant-item-list .variant-item input:checked, .wishlist-list .wishlist-list-input:checked'
            ).forEach(function (input) {
                /** @type {HTMLInputElement} */ (input).checked = false;
            });
            }

            // Keep Confirm disabled whenever a required selection is missing. Re-selecting a
            const hasVariantList = !!document.querySelector('.variant-item-list');
            const hasVariantChecked = !hasVariantList
            || !!document.querySelector('.variant-item-list .variant-item input:checked');
            const hasWishlistChecked = !!document.querySelector('.wishlist-list input.wishlist-list-input:checked');
            if (!hasVariantChecked || !hasWishlistChecked) {
            const confirmButton = document.querySelector('.modal-footer button.btn-save');
            if (confirmButton) {
                confirmButton.classList.add('disable');
                confirmButton.setAttribute('disabled', '');
            }
            }

            if (!AUTO_PRESELECT_DEFAULT_WISHLIST) continue;

            const alreadyChecked = document.querySelector('.wishlist-list input.wishlist-list-input:checked');
            if (alreadyChecked) continue;

            const defaultInput = /** @type {HTMLInputElement | null} */ (document.querySelector(
            '.wishlist-list input.wishlist-list-input[data-wishlist-default="true"]'
            ));
            if (defaultInput) {
            defaultInput.checked = true;
            defaultInput.dispatchEvent(new Event('change', { bubbles: true }));
            }

            // The vendor only enables the Confirm button in response to a user click on a
            const confirmButton = document.querySelector('.modal-footer button.btn-save');
            if (confirmButton) {
            confirmButton.classList.remove('disable');
            confirmButton.removeAttribute('disabled');
            }
        }
        });

        wishlistListObserver.observe(document.body, {
        childList: true,
        subtree: true
        });

        // Same reasoning as above: twc:ready already implies DOMContentLoaded has fired, so this
        (function () {
            document.body.addEventListener("wishlistAddToCartEvent", function (event) {
                const e = /** @type {CustomEvent} */ (event);
                const productId = e.detail?.productId ?? null;
                const variantId = e.detail?.variantId ?? null;
                const quantity = e.detail?.quantity || 1;
        
                const cartLinesUpdateEvent = new CustomEvent("shopify:cart:lines-update", {
                    bubbles: true,
                    cancelable: true,
                });
                cartLinesUpdateEvent.action = "add";
                cartLinesUpdateEvent.context = "wishlist";
                cartLinesUpdateEvent.promise = fetch("/cart.js")
                    .then(function (response) {
                        return response.json();
                    })
                    .then(function (cart) {
                        return {
                            cart: {
                                totalQuantity: cart.item_count,
                            },
                            detail: {
                                didError: false,
                                source: "wishlist",
                                sourceId: "wishlist",
                                productId: productId,
                                variantId: variantId,
                                itemCount: quantity,
                            },
                        };
                    })
                    .catch(function () {
                        return {
                            cart: null,
                            detail: {
                                didError: true,
                                source: "wishlist",
                                sourceId: "wishlist",
                                productId: productId,
                                variantId: variantId,
                                itemCount: quantity,
                            },
                        };
                    });
        
                document.dispatchEvent(cartLinesUpdateEvent);

                // The mini-cart drawer (<mini-cart>, compiled into assets/section-cart-slideout.js)
                // is a Preact component whose item list only renders once its own internal
                // `isLoaded` state flips true - which only happens inside its own listener for
                // window.globalEvents' 'cart.add'/'cart.render' event (a real global, confirmed in
                // assets/module-global-scripts.js: `window.globalEvents = globalEvents`; every
                // bundle referencing a bare `globalEvents` - including this drawer's own listener -
                // resolves to that same shared instance). The wishlist's own add-to-cart flow never
                // went through that pub/sub, so the drawer's listener never fired.
                //
                // This used to instead manually refetch '/?section_id=cart-slideout' and replace
                // #shopify-section-cart-slideout's innerHTML, then call .show() directly - which
                // made things worse: a freshly mounted <mini-cart> always starts with isLoaded
                // false, and nothing outside its own bundle can ever flip it back to true, so the
                // replacement instance was stuck on its loading spinner forever (only the header's
                // item count, being plain server-rendered Liquid, ever visibly updated).
                //
                // Emitting the real event here instead lets the *existing*, never-destroyed
                // <mini-cart> instance handle everything itself, the same way a normal PDP/cart
                // page add-to-cart already does: its own 'cart.add' listener re-fetches the cart,
                // updates its state, and opens the drawer (openMiniCart()) on its own - no manual
                // section swap or .show() call needed here at all.
                fetch("/cart.js")
                    .then(function (response) {
                        return response.json();
                    })
                    .then(function (cart) {
                        if (window.globalEvents && typeof window.globalEvents.emit === 'function') {
                            window.globalEvents.emit('cart.add', cart);
                        }
                    })
                    .catch(function (err) {
                        console.error('Failed to refresh mini cart', err);
                    });
            });
        })();
    });
})();
